import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "hex-border" }
const _hoisted_2 = { class: "hex-fill" }
const _hoisted_3 = {
  key: 1,
  class: "badge-glyph"
}

import { computed } from 'vue';
import { Icon } from '@iconify/vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'HexBadge',
  props: {
    icon: {},
    label: {},
    locked: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;

const isIconifyIcon = computed(() => props.icon.includes(':'));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["hex-badge", { locked: _ctx.locked }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (isIconifyIcon.value)
          ? (_openBlock(), _createBlock(_unref(Icon), {
              key: 0,
              icon: _ctx.icon,
              class: "badge-icon"
            }, null, 8, ["icon"]))
          : (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.icon), 1))
      ])
    ])
  ], 2))
}
}

})